export default "__VITE_ASSET__CFic3qFy__"